export * from './get-location-grant-type';
